export default __webpack_public_path__ + "static/media/food-delivery-logo.c63ca6d5.png";